import * as React from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import TruckVisualization from './TruckVisualization'
import SimplePercentageBar from './SimplePercentageBar'
import { COLORS } from '../../constants'

type LoadBarProps = {
  percentage: number
}

const ToggleButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 10;
  background-color: ${COLORS.primary};
  color: ${COLORS.gray};
  padding: 0.5rem;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;

  &:hover {
    background-color: #2a3548;
    color: ${COLORS.white};
  }

  svg {
    width: 0.75rem;
    height: 0.75rem;
  }
`

const ViewContainer = styled.div`
  position: relative;
  width: 100%;
`

export const LoadBar: React.FC<LoadBarProps> = ({ percentage }) => {
  const [showSimpleView, setShowSimpleView] = useState(false)

  // If simple view is selected, render the SimplePercentageBar component
  if (showSimpleView) {
    return (
      <ViewContainer>
        <ToggleButton
          onClick={() => setShowSimpleView(false)}
          title="Switch to detailed truck view"
        >
          <svg fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 7h3v2H3V7zm0 4h3v2H3v-2zm16-4v10h2v-2h1v-2h-1V7h-2zm-2 0H9v10h8V7zM7 9H3v6h1v2h3v-2h1V9H7z" />
          </svg>
          Truck View
        </ToggleButton>
        <SimplePercentageBar percentage={percentage} />
      </ViewContainer>
    )
  }

  return (
    <ViewContainer>
      <ToggleButton
        onClick={() => setShowSimpleView(true)}
        title="Switch to simple bar view"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        Bar View
      </ToggleButton>
      <TruckVisualization percentage={percentage} />
    </ViewContainer>
  )
}
